import {
  INIT_NEWMESSAGELIST,
  INIT_ZHIBO,
  RE_ZHIBO,
  DES_ZHIBO,
  CHANGE_ZHIBO_LIST,
  INIT_BAOEN_TREE,
  DES_BAOEN_TREE,
  GET_BAOEN_LIST,
  QUERY_BAOEN_LIST,
  QUERY_BAOEN_ALL_LIST,
  INIT_PLAYER,
  DES_PLAYER,
  INIT_PLAYER_MP3,
  SET_COUNTRYCODE,
  PAGECHANGE,
  INDEX_FIRSTLIST,
  PLAYER_NEXT_SECTION,
  EBOOK_TREE_LOADING,
  EBOOK_SEARCH,
  RELOADVIDEO,
  MOBAO_CATEGORY,
  MOBAO_CATEGORY_LOADING,
  MOBAO_LIST,
  MOBAO_CATEGORY_CHANCE,
  MOBAO_LIST_LOADING,
  CHANGE_META_INFO,
  IMG_INDEX,
  RSFS_TYPELIST,
  RSFS_INDEX2,
  RSFS_INFO,
  RSFS_EXINFO,
  FS_RIGHT_INFO_LOADING,
  ENLIGHT_LOADING,
  ENLIGHT_INFO,
  ENLIGHT_INDEX,
  ENLIGHT_PAGE,
  QUERY_ENLIGHT_LIST,
  ENLIGHT_INFO_LOADING,
  EBOOK_PAGE,
  EBOOK_INDEX,
  CARD_INDEX,
  CARD_PAGE,
  CARD_DOWN,
  CARD_INDEX_NEW,
  CARD_PAGE_NEW,
  CARD_DOWN_NEW,
  WALLCARD_LIST_LOADING,
  INIT_PLAYER_ORDER,
  INIT_PLAYER_MP3_ORDER
} from './mutation-types'
import {setStore, getStore, genUUID} from '../utils/storage'
import { ebookPage, ebookIndex, cardIndex, cardPage, cardDown, cardIndexNew, cardPageNew, cardDownNew, mb, mbcategory, ebooksearch, blog, imgIndex, blogmedia, enlightIndex, enlightPage, enlightList, rsfs } from '/api/index.js'
import { zhiboIndex, baoentree, baoentreeQuery, baoentreeQueryAll, dianbo, dianboOrder, specialsubtables, indexFirstlist, playlist, getzhibolist } from '/api/zhibo.js'
export default {
  [CHANGE_META_INFO] (state, metaInfo) {
    state.metaInfo = metaInfo
  },
  // 网页初始化时从本地缓存获取购物车数据
  [INIT_NEWMESSAGELIST] (state) {
    let data = Object.assign({}, {
      categories: 70,
      per_page: 6,
      page: 1
    })
    blog(data).then(res => {
      console.log('blog:%o', res)
      state.newMessageList = res
      state.newMessageLoading = false
    }, res => {})
  },
  [INIT_ZHIBO] (state, data) {
    zhiboIndex(data).then(res => {
      if (res.code === 0) {
        let s = {
          src: res.channelinfo.videoHlsUrl,
          type: 'application/x-mpegurl',
          live: true
        }
        let sourceArray = [s]
        console.log('源數組大小%s', sourceArray.length)
        state.playerConfig = {
          ratio: 9 / 16,
          autoplay: false,
          debug: false,
          share: false,
          chromecast: false,
          // analytics: 'UA-116844336-2',
          poster: res.channelinfo.poster,
          clip: {
            sources: sourceArray
          }
        }
        state.zhiboReady = true
        state.channelinfo = res.channelinfo
        state.liveContent = res.channelinfo.liveContent
        state.bestServerInfo = res.channelinfo.bestServerInfo
        var curr = res.channelinfo.currentPlaylist
        state.flushtime = curr.flushtime
        state.zhibocountry = res.channelinfo.country
        if (getStore('hid') == null) {
          let uuid = genUUID(5)
          setStore('hid', uuid)
          state.hid = uuid
        } else {
          state.hid = getStore('hid')
        }
        if (getStore('aid') == null) {
          let uuid2 = Date.now()
          setStore('hid', uuid2)
          state.aid = uuid2
        } else {
          state.aid = getStore('aid')
        }
      } else {
        state.channelinfo = null
        state.zhiboReady = false
        state.flushtime = 1500
      }
    }, res => {})
  },
  [CHANGE_ZHIBO_LIST] (state, data) {
    getzhibolist(data).then(res => {
      if (res.code === 0) {
        let s = {
          src: res.channelinfo.videoHlsUrl,
          type: 'application/x-mpegurl',
          live: true
        }
        let sourceArray = [s]
        console.log('源數組大小%s', sourceArray.length)
        state.playerConfig = {
          ratio: 9 / 16,
          autoplay: false,
          debug: false,
          share: false,
          chromecast: false,
          // analytics: 'UA-116844336-2',
          clip: {
            sources: sourceArray
          }
        }
        state.zhiboReady = true
        state.channelinfo = res.channelinfo
        state.liveContent = res.channelinfo.liveContent
        state.bestServerInfo = res.channelinfo.bestServerInfo
        var curr = res.channelinfo.currentPlaylist
        state.flushtime = curr.flushtime
        state.zhibocountry = res.channelinfo.country
        if (getStore('hid') == null) {
          let uuid = genUUID(5)
          setStore('hid', uuid)
          state.hid = uuid
        } else {
          state.hid = getStore('hid')
        }
        if (getStore('aid') == null) {
          let uuid2 = Date.now()
          setStore('hid', uuid2)
          state.aid = uuid2
        } else {
          state.aid = getStore('aid')
        }
      } else {
        state.channelinfo = null
        state.zhiboReady = false
        state.flushtime = 1500
      }
    }, res => {})
  },
  [RE_ZHIBO] (state, data) {
    zhiboIndex(data).then(res => {
      if (res.code === 0) {
        state.channelinfo = res.channelinfo
        state.liveContent = res.channelinfo.liveContent
        state.bestServerInfo = res.channelinfo.bestServerInfo
        var curr = res.channelinfo.currentPlaylist
        state.flushtime = curr.flushtime
      } else {
        state.channelinfo = null
        state.zhiboReady = false
        state.flushtime = 1500
      }
    }, res => {})
  },
  [INIT_BAOEN_TREE] (state) {
    baoentree().then(res => {
      if (res.code === 0) {
        state.preUrl = res.speechposterUrl
        state.baoenTree = res.categories[0]
        state.topspeech = res.topspeech
        state.recentspeech = res.recentspeech
        state.hotspeech = res.hotspeech.data
        state.ftpstatement = res.ftpstatement
      } else {
      }
    }, res => {})
  },
  [INDEX_FIRSTLIST] (state) {
    specialsubtables().then(res => {
      if (res.code === 0) {
        state.specialtopicList = res.sutables.data
        state.specialtopicList.push({'type': 1, 'title': '講演節錄', 'url': 'https://www.amtb.tw/#/lectureroom?categoryid=43'})
      } else {
        state.indexFirstLoading = true
      }
    }, res => {})
    indexFirstlist().then(res => {
      if (res.code === 0) {
        state.indexFirstList = res.topspeechhome.data
        state.indexFirstLoading = false
      } else {
        state.indexFirstLoading = true
      }
    }, res => {})
  },
  [GET_BAOEN_LIST] (state, paramer) {
    state.baoenloading = true
    state.baoenTree.code = 1
    baoentreeQuery(paramer).then(res => {
      if (res.code === 0) {
        state.baoenloading = false
        state.baoenTree.code = 0
        state.baoenTree.category = res.category
        state.baoenCategoryList = res.sutables
        state.topspeechShow = false
      } else {
      }
    }, res => {})
  },
  [QUERY_BAOEN_LIST] (state, paramer) {
    state.queryloading = true
    baoentreeQuery(paramer).then(res => {
      if (res.code === 0) {
        state.baoenQueryList = res.sutables.data
        state.queryloading = false
      } else {
      }
    }, res => {})
  },
  [QUERY_BAOEN_ALL_LIST] (state, paramer) {
    state.queryloading = true
    baoentreeQueryAll(paramer).then(res => {
      if (res.code === 0) {
        state.baoenQueryList = res.sutables.data
        state.baoenQueryListSize = res.sutables.total
        state.queryloading = false
      } else {
      }
    }, res => {})
  },
  [INIT_PLAYER] (state, paramer) {
    dianbo(paramer).then(res => {
      if (res.code === 0) {
        state.mediaData = res
        state.jiangtangInfo = res.jiangtanginfo
        state.dianbobestserverinfo = res.bestserverinfo
        state.dianbodoc = res.jiangtanginfo.doc
        state.docAllHits = res.jiangtanginfo.doc.all_hits
        state.playlistindex = res.jiangtanginfo.playlistindex
        let playlistindex = res.jiangtanginfo.playlistindex
        state.subtable = res.jiangtanginfo.subtable
        var host = res.bestserverinfo.domain
        var list = res.jiangtanginfo.mp4list
        var list2 = res.jiangtanginfo.mp3list
        state.mp4total = list.length
        state.mp3total = list2.length
        var sourceList = []
        var mp4list = []
        var mp3list = []
        var url = 'https://' + res.bestserverinfo.domain
        list.forEach(function (item, index) {
          var mp4Item = {name: item.titleshow, itemidparent: item.itemidparent, itemidchildren: item.itemidchildren, voice: item.voice, number: item.id, poster: item.poster, index: index, title: item.title, item: item, downurl: url + item.fileHttpUrl}
          if (playlistindex === index) {
            mp4Item.isplay = true
          } else {
            mp4Item.isplay = false
          }
          mp4list.push(mp4Item)
        })
        list2.forEach(function (item, index) {
          var mp3Item = {name: item.titleshow, itemidparent: item.itemidparent, itemidchildren: item.itemidchildren, voice: item.voice, number: item.id, poster: item.poster, title: item.title, item: item, downurl: url + item.fileHttpUrl}
          if (playlistindex === index) {
            mp3Item.isplay = true
          } else {
            mp3Item.isplay = false
          }
          mp3list.push(mp3Item)
        })
        state.mp4list = mp4list
        state.mp3list = mp3list
        // state.mp4total = list.length
        // state.mp3total = list2.length
        list.forEach(function (item) {
          var s1 = {
            type: 'application/x-mpegurl',
            src: 'https://' + host + item.fileHlsUrl
          }
          var s2 = {
            type: 'video/mp4',
            src: 'https://' + host + item.fileHttpUrl
          }
          var sourceArray = [s1, s2]
          var sourceItem = {sources: sourceArray}
          sourceList.push(sourceItem)
          state.dianboplayerConfig = {
            ratio: 9 / 16,
            autoplay: false,
            debug: false,
            share: true,
            facebook: true,
            chromecast: true,
            // analytics: 'UA-116844336-2',
            playlist: sourceList,
            hlsjs: {
              safari: false,
              recoverMediaError: true,
              recoverNetworkError: true
            }
          }
          state.dianboLoading = false
          state.countryCode = res.jiangtanginfo.autocode
          state.dianbocountry = res.jiangtanginfo.autocode
          if (getStore('hid') == null) {
            let uuid = genUUID(5)
            setStore('hid', uuid)
            state.hid = uuid
          } else {
            state.hid = getStore('hid')
          }
          if (getStore('aid') == null) {
            let uuid2 = Date.now()
            setStore('hid', uuid2)
            state.aid = uuid2
          } else {
            state.aid = getStore('aid')
          }
        })
      } else {
        console.log('dianbo shibao')
      }
    }, res => {
      console.log('dianbo shibao')
    })
  },
  [PLAYER_NEXT_SECTION] (state, paramer) {
    playlist(paramer.video).then(res => {
      if (res.code === 0) {
        state.dianbodoc = res.doc
        state.docAllHits = res.doc.all_hits
        state.playlistindex = paramer.index
      } else {
        console.log('dianbo shibao')
      }
    }, res => {
      console.log('dianbo shibao')
    })
  },
  [INIT_PLAYER_MP3] (state, paramer) {
    dianbo(paramer).then(res => {
      if (res.code === 0) {
        console.log('dianbo chenggong')
        state.mediaData = res
        state.jiangtangInfo = res.jiangtanginfo
        state.dianbobestserverinfo = res.bestserverinfo
        state.dianbodoc = res.jiangtanginfo.doc
        state.docAllHits = res.jiangtanginfo.doc.all_hits
        state.playlistindex = res.jiangtanginfo.playlistindex
        let playlistindex = res.jiangtanginfo.playlistindex
        state.subtable = res.jiangtanginfo.subtable
        var host = res.bestserverinfo.domain
        var list = res.jiangtanginfo.mp4list
        var list2 = res.jiangtanginfo.mp3list
        state.mp4total = list.length
        state.mp3total = list2.length
        var sourceList = []
        var mp4list = []
        var mp3list = []
        var url = 'https://' + res.bestserverinfo.domain
        list.forEach(function (item, index) {
          var mp4Item = {name: item.titleshow, itemidparent: item.itemidparent, itemidchildren: item.itemidchildren, voice: item.voice, index: index, number: item.id, poster: item.poster, title: item.title, item: item, downurl: url + item.fileHttpUrl}
          if (playlistindex === index) {
            mp4Item.isplay = true
          } else {
            mp4Item.isplay = false
          }
          mp4list.push(mp4Item)
        })
        list2.forEach(function (item, index) {
          var mp3Item = {name: item.titleshow, itemidparent: item.itemidparent, itemidchildren: item.itemidchildren, voice: item.voice, index: index, number: item.id, poster: item.poster, title: item.title, item: item, downurl: url + item.fileHttpUrl}
          if (playlistindex === index) {
            mp3list.isplay = true
          } else {
            mp3list.isplay = false
          }
          mp3list.push(mp3Item)
        })
        state.mp4list = mp4list
        state.mp3list = mp3list
        // state.mp4total = list.length
        // state.mp3total = list2.length
        list2.forEach(function (item) {
          var s2 = {
            type: 'audio/mpeg',
            src: 'https://' + host + item.fileHttpUrl
          }
          var sourceArray = [s2]
          var sourceItem = {audio: true, coverImage: item.poster, sources: sourceArray}
          sourceList.push(sourceItem)
        })
        state.dianboplayerConfig = {
          ratio: 9 / 16,
          autoplay: false,
          debug: false,
          share: true,
          facebook: true,
          chromecast: false,
          // analytics: 'UA-116844336-2',
          playlist: sourceList,
          hlsjs: {
            safari: false,
            recoverMediaError: true,
            recoverNetworkError: true
          }
        }
        state.dianboLoading = false
        state.dianbocountry = res.jiangtanginfo.autocode
        if (getStore('hid') == null) {
          let uuid = genUUID(5)
          setStore('hid', uuid)
          state.hid = uuid
        } else {
          state.hid = getStore('hid')
        }
        if (getStore('aid') == null) {
          let uuid2 = Date.now()
          setStore('hid', uuid2)
          state.aid = uuid2
        } else {
          state.aid = getStore('aid')
        }
      } else {
        console.log('dianbo fail')
      }
    }, res => {
      console.log('dianbo fail')
    })
  },
  [PAGECHANGE] (state, page) {
    page = page - 1
    var list = state.jiangtangInfo.mp4list
    var list2 = state.jiangtangInfo.mp3list
    var mp4list = []
    var mp3list = []
    var url = 'https://' + state.dianbobestserverinfo.domain
    let i = 0
    let j = 0
    list.forEach(function (item, index) {
      if (page * 15 <= index && i < 15) {
        i++
        var mp4Item = {name: item.titleshow, title: item.title, item: item, downurl: url + item.fileHttpUrl}
        mp4list.push(mp4Item)
      }
    })
    list2.forEach(function (item, index) {
      if (page * 15 <= index && j < 15) {
        j++
        var mp3Item = {name: item.titleshow, title: item.title, item: item, downurl: url + item.fileHttpUrl}
        mp3list.push(mp3Item)
      }
    })
    state.mp4list = mp4list
    state.mp3list = mp3list
  },
  [RELOADVIDEO] (state) {
    state.dianboLoading = true
    state.dianbodoc.jingwencontent = ''
  },
  [DES_PLAYER] (state) {
    state.dianboLoading = true
    state.dianbodoc = {jingwencontent: ''}
    state.countryCode = '0'
  },
  [DES_ZHIBO] (state) {
    state.zhiboReady = false
  },
  [DES_BAOEN_TREE] (state) {
    state.topspeechShow = true
    state.baoenQueryList = []
  },
  [SET_COUNTRYCODE] (state, paramer) {
    state.countryCode = paramer
  },
  [MOBAO_CATEGORY] (state, param) {
    let imgArray = [
      {src: 'fayu_t.png', src2: 'fayu_tred.png'},
      {src: 'shuming_t.png', src2: 'shuming_tred.png'},
      {src: 'daochang_t.png', src2: 'daochang_tred.png'},
      {src: 'fashi_t.png', src2: 'fashi_tred.png'},
      {src: 'duiju_t.png', src2: 'duiju_tred.png'},
      {src: 'duanju_t.png', src2: 'duanju_tred.png'},
      {src: 'yuanxing_t.png', src2: 'yuanxing_tred.png'},
      {src: 'shangxing_t.png', src2: 'shangxing_tred.png'},
      {src: 'zhonjiao_t.png', src2: 'zhonjiao_tred.png'},
      {src: 'others_t.png', src2: 'others_tred.png'},
      {src: 'yinzhang_t.png', src2: 'yinzhang_tred.png'}
    ]
    mbcategory(param).then(result => {
      if (result.code === 0) {
        let category = result.data.mbcategorys
        category.forEach((item, index) => {
          if (index === 0) {
            item.icon = imgArray[index].src2
          } else {
            item.icon = imgArray[index].src
          }
        })
        state.mobaoCategory = category
        state.mobaoList = result.data.mblists
        state.mobaoListLoading = false
      } else {

      }
      console.log('墨寶類別%o', result)
    })
  },
  [MOBAO_CATEGORY_LOADING] (state, param) {
    state.mobaoCategoryLoading = true
  },
  [MOBAO_LIST] (state, param) {
    mb(param).then(result => {
      if (result.code === 0) {
        state.mobaoList = result.data.mblists
        state.mobaoListLoading = false
      } else {

      }
      console.log('墨寶類別%o', result)
    })
  },
  [MOBAO_LIST_LOADING] (state, param) {
    state.mobaoListLoading = true
  },
  [MOBAO_CATEGORY_CHANCE] (state, id) {
    let imgArray = [
      {src: 'fayu_t.png', src2: 'fayu_tred.png'},
      {src: 'shuming_t.png', src2: 'shuming_tred.png'},
      {src: 'daochang_t.png', src2: 'daochang_tred.png'},
      {src: 'fashi_t.png', src2: 'fashi_tred.png'},
      {src: 'duiju_t.png', src2: 'duiju_tred.png'},
      {src: 'duanju_t.png', src2: 'duanju_tred.png'},
      {src: 'yuanxing_t.png', src2: 'yuanxing_tred.png'},
      {src: 'shangxing_t.png', src2: 'shangxing_tred.png'},
      {src: 'zhonjiao_t.png', src2: 'zhonjiao_tred.png'},
      {src: 'others_t.png', src2: 'others_tred.png'},
      {src: 'yinzhang_t.png', src2: 'yinzhang_tred.png'}
    ]
    let list = state.mobaoCategory
    list.forEach((item, inedx) => {
      if (id === inedx) {
        item.icon = imgArray[inedx].src2
      } else {
        item.icon = imgArray[inedx].src
      }
    })
    state.mobaoCategory = list
  },
  [IMG_INDEX] (state) {
    imgIndex().then(res => {
      let resArray = []
      let funcArray = []
      res.forEach((item, index) => {
        funcArray.push(blogmedia({}, item.featured_media))
        let obj = {
          title: item.title.rendered,
          icon: item.id,
          link: item.link,
          date: item.date
        }
        resArray.push(obj)
      })
      Promise.all(funcArray).then(result => {
        resArray.forEach((item, i) => {
          item.icon = result[i].media_details.sizes.full.source_url
        })
        state.indexbottom = resArray
        state.indexbottomLoading = false
      }, fail => {
        console.log('批量请求图片失败了%o', fail)
      })
    }, res => {
      console.log('请求五篇文章失败了%o', res)
    })
  },
  [EBOOK_SEARCH] (state, param) {
    ebooksearch(param).then(result => {
      state.ebookTreeLoading = false
      let obj = result.typelist[0]
      let theitem = obj.item
      theitem.forEach((item, index) => {
        let a = item.content + ''
        let b = item.content + ''
        if (a === '') {
          item.content = '未找到相應書籍'
          item.src = '未找到相應書籍'
          item.thumbnail = '/pdf/'
        } else {
          let regexp1 = /&gt;/g
          let regexp2 = /&lt;/g
          let matchStr1 = a.search(regexp1)
          a = a.substring(matchStr1 + 4)
          let matchStr2 = a.search(regexp2)
          a = a.substring(0, matchStr2)
          a = a.replace(/(^\s*)|(\s*$)/g, '')
          let match1 = b.search(regexp1)
          b = b.substring(0, match1)
          var wps = []
          var start = 0
          var pos = b.indexOf(';')

          while (pos > -1) {
            wps.push(b.substr(start, pos - start))
            start = pos + 1
            pos = b.indexOf(';', pos + 1)
          }
          let c = wps[2]
          c = c.replace(/&quot/g, '')
          c = c.substring(3)
          c = '/' + c
          // a = a.substring(matchStr1.index, matchStr2.index)
          // a = a.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&apos;/g, "'")
          item.content = a
          item.src = c
          item.thumbnail = '/pdf/' + item.thumbnail
        }
      })
      obj.item = theitem
      state.ebookItem = obj
    }, res => {
      console.log('網絡查詢失敗了:%o', res)
    })
  },
  /**
   * 认识法师全部数据
   * @param {} state
   * @param {*} data
   */
  [RSFS_INDEX2] (state, data) {
    rsfs(data).then(res => {
      if (res.code === 200) {
        state.rsfsTypeList = res.data.typeList
        state.rsfsList = res.data.list
        state.rsfsObject = res.data.comprehend
        state.rsfsTypes = res.data.types
      }
    }, res => {
      console.error(res)
    })
  },
  /**
   *
   * @param {点击折叠后展开下面的子菜单} state
   * @param {*} data
   */
  [RSFS_TYPELIST] (state, data) {
    switch (data) {
      case 1:
        state.rsfsList = state.rsfsTypeList.list1
        break
      case 2:
        state.rsfsList = state.rsfsTypeList.list2
        break
      case 3:
        state.rsfsList = state.rsfsTypeList.list3
        break
      case 4:
        state.rsfsList = state.rsfsTypeList.list4
        break
      case 5:
        state.rsfsList = state.rsfsTypeList.list5
        break
      case 6:
        state.rsfsList = state.rsfsTypeList.list6
        break
      case 7:
        state.rsfsList = state.rsfsTypeList.list7
        break
      case 8:
        state.rsfsList = state.rsfsTypeList.list8
        break
    }
    state.fsTreeLoading = false
  },
  /**
   *
   * @param {认识法师点击title显示内容} state
   * @param {*} data
   */
  [RSFS_INFO] (state, data) {
    state.rsfsList.forEach((item) => {
      if (item.id === data) {
        state.rsfsObject = item
      }
    })
    state.fsInfoLoading = false
  },
  [RSFS_EXINFO] (state, data) {
    let theList = []
    switch (data.type) {
      case 1:
        theList = state.rsfsTypeList.list1
        break
      case 2:
        theList = state.rsfsTypeList.list2
        break
      case 3:
        theList = state.rsfsTypeList.list3
        break
      case 4:
        theList = state.rsfsTypeList.list4
        break
      case 5:
        theList = state.rsfsTypeList.list5
        break
      case 6:
        theList = state.rsfsTypeList.list6
        break
      case 7:
        theList = state.rsfsTypeList.list7
        break
      case 8:
        theList = state.rsfsTypeList.list8
        break
    }
    theList.forEach((item) => {
      if (item.id === data.id) {
        state.rsfsObject = item
      }
    })
    state.fsInfoLoading = false
  },
  [FS_RIGHT_INFO_LOADING] (state, param) {
    state.fsInfoLoading = true
  },
  [ENLIGHT_INDEX] (state, paramas) {
    enlightIndex(paramas).then(res => {
      if (res.code === 200) {
        state.enlightTypes = res.data.typeList
        state.enlightPage = res.data.list
        state.enlightObject = res.data.list.rows[0]
      }
      state.enlightLoading = false
    }, res => {
      console.error(res)
    })
  },
  [ENLIGHT_PAGE] (state, paramas) {
    enlightPage(paramas).then(res => {
      if (res.code === 200) {
        state.enlightPage = res.data.list
      }
      state.enlightLoading = false
    }, res => {
      console.error(res)
    })
  },
  [QUERY_ENLIGHT_LIST] (state, paramas) {
    enlightList(paramas).then(res => {
      if (res.code === 200) {
        state.enlightPage = res.data.list
      }
      state.enlightLoading = false
    }, res => {
      console.error(res)
    })
  },
  [ENLIGHT_INFO] (state, param) {
    state.enlightPage.rows.forEach((item) => {
      if (item.amtbIndex === param) {
        state.enlightObject = item
      }
    })
    state.enlightInfoLoading = false
  },

  [ENLIGHT_LOADING] (state) {
    state.enlightLoading = true
  },
  [ENLIGHT_INFO_LOADING] (state) {
    state.enlightInfo = {title: '', content: ''}
    state.enlightInfoLoading = true
  },
  [EBOOK_PAGE] (state, param) {
    ebookPage(param).then(res => {
      if (res.code === 200) {
        state.ebookPage = res.data.list
      }
      state.ebookTreeLoading = false
    }, res => {
      console.error(res)
    })
  },
  [EBOOK_INDEX] (state, param) {
    ebookIndex(param).then(res => {
      if (res.code === 200) {
        state.ebookPage = res.data.list
        state.ebookTypes = res.data.typeList
        state.ebookTops = res.data.topList
      }
      state.ebookTreeLoading = false
    }, res => {
      console.error(res)
    })
  },
  [EBOOK_TREE_LOADING] (state, param) {
    state.ebookTreeLoading = true
  },
  [CARD_INDEX] (state, param) {
    cardIndex(param).then(res => {
      if (res.code === 200) {
        state.cardPage = res.data.list
        state.cardTypes = res.data.typeList
      }
      state.wallcardListLoading = false
    }, res => {
      console.error(res)
    })
  },
  [CARD_PAGE] (state, param) {
    cardPage(param).then(res => {
      if (res.code === 200) {
        state.cardPage = res.data.list
      }
      state.wallcardListLoading = false
    }, res => {
      console.error(res)
    })
  },
  [CARD_DOWN] (state, param) {
    cardDown(param).then(res => {
      console.log(res)
    }, res => {
      console.error(res)
    })
  },
  [CARD_INDEX_NEW] (state, param) {
    cardIndexNew(param).then(res => {
      if (res.code === '200') {
        // state.cardPage = res.data.list // ? 改成调用获取接口查询第一页来。
        state.cardTypes = res.data
        var list = res.data
        var typelist = []
        list.forEach(function (item, index) {
          var typeItem = { id: item.id, name: item.name, idname: item.id + '-' + item.name }
          typelist.push(typeItem)
        })
        state.cardTypes = typelist
        var catalogueId = res.data[0].id
        if (catalogueId) {
          cardPageNew({ catalogueId: catalogueId, startPage: 1, pageSize: 20 }).then(res1 => {
            if (res1.code === '200') {
              state.cardPage = res1.data
            }
          }, res1 => {
            console.error(res1)
          })
        }
      }
      state.wallcardListLoading = false
    }, res => {
      console.error(res)
    })
  },
  [CARD_PAGE_NEW] (state, param) {
    cardPageNew(param).then(res => {
      if (res.code === '200') {
        state.cardPage = res.data
      }
      state.wallcardListLoading = false
    }, res => {
      console.error(res)
    })
  },
  [CARD_DOWN_NEW] (state, cardId) {
    cardDownNew(cardId).then(res => {
      console.log(res)
    }, res => {
      console.error(res)
    })
  },
  [WALLCARD_LIST_LOADING] (state) {
    state.wallcardListLoading = true
  },
  [INIT_PLAYER_ORDER] (state, { paramer, sortType }) {
    dianboOrder(paramer, sortType).then(res => {
      if (res.code === 0) {
        state.mediaData = res
        state.jiangtangInfo = res.jiangtanginfo
        state.dianbobestserverinfo = res.bestserverinfo
        state.dianbodoc = res.jiangtanginfo.doc
        state.playlistindex = res.jiangtanginfo.playlistindex
        let playlistindex = res.jiangtanginfo.playlistindex
        state.subtable = res.jiangtanginfo.subtable
        var host = res.bestserverinfo.domain
        var list = res.jiangtanginfo.mp4list
        var list2 = res.jiangtanginfo.mp3list
        state.mp4total = list.length
        state.mp3total = list2.length
        var sourceList = []
        var mp4list = []
        var mp3list = []
        var url = 'https://' + res.bestserverinfo.domain
        list.forEach(function (item, index) {
          var mp4Item = {name: item.titleshow, itemidparent: item.itemidparent, itemidchildren: item.itemidchildren, voice: item.voice, number: item.id, poster: item.poster, index: index, title: item.title, item: item, downurl: url + item.fileHttpUrl}
          if (playlistindex === index) {
            mp4Item.isplay = true
          } else {
            mp4Item.isplay = false
          }
          mp4list.push(mp4Item)
        })
        list2.forEach(function (item, index) {
          var mp3Item = {name: item.titleshow, itemidparent: item.itemidparent, itemidchildren: item.itemidchildren, voice: item.voice, number: item.id, poster: item.poster, title: item.title, item: item, downurl: url + item.fileHttpUrl}
          if (playlistindex === index) {
            mp3Item.isplay = true
          } else {
            mp3Item.isplay = false
          }
          mp3list.push(mp3Item)
        })
        state.mp4list = mp4list
        state.mp3list = mp3list
        // state.mp4total = list.length
        // state.mp3total = list2.length
        list.forEach(function (item) {
          var s1 = {
            type: 'application/x-mpegurl',
            src: 'https://' + host + item.fileHlsUrl
          }
          var s2 = {
            type: 'video/mp4',
            src: 'https://' + host + item.fileHttpUrl
          }
          var sourceArray = [s1, s2]
          var sourceItem = {sources: sourceArray}
          sourceList.push(sourceItem)
          state.dianboplayerConfig = {
            ratio: 9 / 16,
            autoplay: false,
            debug: false,
            share: true,
            facebook: true,
            chromecast: true,
            // analytics: 'UA-116844336-2',
            playlist: sourceList,
            hlsjs: {
              safari: false,
              recoverMediaError: true,
              recoverNetworkError: true
            }
          }
          state.dianboLoading = false
          state.countryCode = res.jiangtanginfo.autocode
          state.dianbocountry = res.jiangtanginfo.autocode
          if (getStore('hid') == null) {
            let uuid = genUUID(5)
            setStore('hid', uuid)
            state.hid = uuid
          } else {
            state.hid = getStore('hid')
          }
          if (getStore('aid') == null) {
            let uuid2 = Date.now()
            setStore('hid', uuid2)
            state.aid = uuid2
          } else {
            state.aid = getStore('aid')
          }
        })
      } else {
        console.log('dianbo shibao')
      }
    }, res => {
      console.log('dianbo shibao')
    })
  },
  [INIT_PLAYER_MP3_ORDER] (state, { paramer, sortType }) {
    dianboOrder(paramer, sortType).then(res => {
      if (res.code === 0) {
        console.log('dianbo chenggong')
        state.mediaData = res
        state.jiangtangInfo = res.jiangtanginfo
        state.dianbobestserverinfo = res.bestserverinfo
        state.dianbodoc = res.jiangtanginfo.doc
        state.playlistindex = res.jiangtanginfo.playlistindex
        let playlistindex = res.jiangtanginfo.playlistindex
        state.subtable = res.jiangtanginfo.subtable
        var host = res.bestserverinfo.domain
        var list = res.jiangtanginfo.mp4list
        var list2 = res.jiangtanginfo.mp3list
        state.mp4total = list.length
        state.mp3total = list2.length
        var sourceList = []
        var mp4list = []
        var mp3list = []
        var url = 'https://' + res.bestserverinfo.domain
        list.forEach(function (item, index) {
          var mp4Item = {name: item.titleshow, itemidparent: item.itemidparent, itemidchildren: item.itemidchildren, voice: item.voice, index: index, number: item.id, poster: item.poster, title: item.title, item: item, downurl: url + item.fileHttpUrl}
          if (playlistindex === index) {
            mp4Item.isplay = true
          } else {
            mp4Item.isplay = false
          }
          mp4list.push(mp4Item)
        })
        list2.forEach(function (item, index) {
          var mp3Item = {name: item.titleshow, itemidparent: item.itemidparent, itemidchildren: item.itemidchildren, voice: item.voice, index: index, number: item.id, poster: item.poster, title: item.title, item: item, downurl: url + item.fileHttpUrl}
          if (playlistindex === index) {
            mp3list.isplay = true
          } else {
            mp3list.isplay = false
          }
          mp3list.push(mp3Item)
        })
        state.mp4list = mp4list
        state.mp3list = mp3list
        // state.mp4total = list.length
        // state.mp3total = list2.length
        list2.forEach(function (item) {
          var s2 = {
            type: 'audio/mpeg',
            src: 'https://' + host + item.fileHttpUrl
          }
          var sourceArray = [s2]
          var sourceItem = {audio: true, coverImage: item.poster, sources: sourceArray}
          sourceList.push(sourceItem)
        })
        state.dianboplayerConfig = {
          ratio: 9 / 16,
          autoplay: false,
          debug: false,
          share: true,
          facebook: true,
          chromecast: false,
          // analytics: 'UA-116844336-2',
          playlist: sourceList,
          hlsjs: {
            safari: false,
            recoverMediaError: true,
            recoverNetworkError: true
          }
        }
        state.dianboLoading = false
        state.dianbocountry = res.jiangtanginfo.autocode
        if (getStore('hid') == null) {
          let uuid = genUUID(5)
          setStore('hid', uuid)
          state.hid = uuid
        } else {
          state.hid = getStore('hid')
        }
        if (getStore('aid') == null) {
          let uuid2 = Date.now()
          setStore('hid', uuid2)
          state.aid = uuid2
        } else {
          state.aid = getStore('aid')
        }
      } else {
        console.log('dianbo fail')
      }
    }, res => {
      console.log('dianbo fail')
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js